(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/utils/products/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/utils/products/assets/javascripts/prescript.js'); (function() {
  svs.utils = svs.utils || {};
  svs.utils.products = svs.utils.products || {};
})();

 })(window);